<dx-popup
    title="Storage/Dump Site"
    [width]="600"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    @if (hasChanges()) {
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Save And New', type: 'success', onClick: saveAndNew }"
        >
        </dxi-popup-toolbar-item>
    }
    @if (hasChanges()) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
        </dxi-popup-toolbar-item>
    }
    @if (hasChanges()) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
        </dxi-popup-toolbar-item>
    }
    @if (!hasChanges()) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Close', type: 'success', onClick: close }">
        </dxi-popup-toolbar-item>
    }
    <dx-form [formData]="storageDumpSite">
        <dxi-form-item itemType="group" caption="Site Info">
            <dxi-form-item dataField="name"></dxi-form-item>
            <dxi-form-item itemType="group" [colCount]="2">
                <dxi-form-item dataField="dump"></dxi-form-item>
                <dxi-form-item dataField="storage"></dxi-form-item>
            </dxi-form-item>
        </dxi-form-item>
        <dxi-form-item
            dataField="tonExpenseId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: tonExpenses, valueExpr: 'id', displayExpr: 'name' }"
            [label]="{ text: 'Ton Expense' }"
        >
        </dxi-form-item>
        <dxi-form-item [label]="{ text: 'Address Lookup' }" [colSpan]="2">
            <div *dxTemplate>
                <app-address-lookup (onLocationChanged)="locationChanged($event)"></app-address-lookup>
            </div>
        </dxi-form-item>
        <dxi-form-item itemType="group" caption="Address" [colCount]="2">
            <dxi-form-item dataField="address1" [colSpan]="2"></dxi-form-item>
            <dxi-form-item dataField="address2" [colSpan]="2"></dxi-form-item>
            <dxi-form-item dataField="city"></dxi-form-item>
            <dxi-form-item dataField="state"></dxi-form-item>
            <dxi-form-item dataField="zip"></dxi-form-item>
            <dxi-form-item dataField="county"></dxi-form-item>
            <dxi-form-item dataField="latitude"></dxi-form-item>
            <dxi-form-item dataField="longitude"></dxi-form-item>
        </dxi-form-item>
        <dxi-form-item
            dataField="note"
            editorType="dxTextArea"
            [label]="{ text: 'Notes' }"
            [editorOptions]="{ height: 100 }"
        ></dxi-form-item>
    </dx-form>
</dx-popup>
